import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Colors } from "design-system";

const Logo = React.memo(({ width = "130", height = "50", theme = "dark" }) => {
  const st0 = useMemo(
    () => ({ fill: theme === "light" ? Colors.Grey900 : Colors.White }),
    [theme]
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0  0 130 28.2"
      width={width}
      height={height}
    >
      {/* Top wordmark row */}
      <g>
        <rect style={st0} y=".2" width="1.2" height="7.7" />
        <polygon
          style={st0}
          points="10.2 5.9 5.6 .2 4.4 .2 4.4 7.8 5.6 7.8 5.6 2.1 10.2 7.8 11.4 7.8 11.4 .2 10.2 .2 10.2 5.9"
        />
        <rect style={st0} x="21" y=".2" width="1.2" height="7.7" />
        <rect style={st0} x="37.9" y=".2" width="1.2" height="7.7" />
        <path
          style={st0}
          d="M45.5,0c-2.3,0-4,1.8-4,4s1.7,4,4,4,4-1.8,4-4-1.7-4-4-4ZM45.5,6.9c-1.6,0-2.7-1.3-2.7-2.9s1.2-2.8,2.7-2.8,2.7,1.3,2.7,2.8-1.2,2.9-2.7,2.9Z"
        />
        <polygon
          style={st0}
          points="57.7 .2 57.7 5.9 53.1 .2 51.9 .2 51.9 7.8 53.1 7.8 53.1 2.1 57.7 7.8 58.9 7.8 58.9 .2 57.7 .2"
        />
        <path
          style={st0}
          d="M26.6,6.3V.2h-1.2v6.4c0,.6.5,1.2,1.2,1.2h3v-1.1c0,0-2.7,0-2.7,0-.2,0-.4-.2-.4-.4h0Z"
        />
        <path
          style={st0}
          d="M14.5,1.4v6.4h1.2v-3.4h2.6v-1.1c.1,0-2.6,0-2.6,0v-1.6c0-.2.2-.4.4-.4h2.8V.2h-3.1c-.7,0-1.2.6-1.2,1.2h0Z"
        />
        <path
          style={st0}
          d="M32.8,6.3V.2h-1.2v6.4c0,.6.5,1.2,1.2,1.2h3v-1.1c0,0-2.7,0-2.7,0-.2,0-.4-.2-.4-.4h0Z"
        />
      </g>

      {/* Bottom logo row */}
      <g>
        <polygon style={st0} points="36.3 24.2 36.2 24.4 36.2 24.4 36.3 24.2" />
        <g>
          <path
            style={st0}
            d="M30.5,26v2.1h-10.7v-14.9h10.5v2.1h-8.2v3.9h6.5v2.1h-6.5v4.6h8.4Z"
          />
          <path
            style={st0}
            d="M38.9,13.3c2.1,0,3.8.7,5.3,2.2,1.5,1.5,2.2,3.2,2.2,5.2s-.7,3.8-2.2,5.2-3.3,2.2-5.3,2.2h-5.2v-14.9h5.2ZM36.1,15.4v10.6h2.9c1.4,0,2.7-.5,3.7-1.5,1-1,1.5-2.3,1.5-3.8s-.5-2.7-1.5-3.8-2.2-1.5-3.7-1.5h-2.9Z"
          />
          <path style={st0} d="M49.9,13.3h2.3v14.9h-2.3v-14.9Z" />
          <path
            style={st0}
            d="M60.9,13.3h2.3l6.2,14.9h-2.4l-1.6-3.9h-6.6l-1.6,3.9h-2.4l6.2-14.9h0ZM59.6,22.1h4.9l-2.4-6.2-2.4,6.2Z"
          />
          <path
            style={st0}
            d="M96.1,13.3h2.3l6.2,14.9h-2.4l-1.6-3.9h-6.6l-1.6,3.9h-2.4l6.2-14.9h0ZM94.9,22.1h4.9l-2.4-6.2-2.4,6.2h0Z"
          />
          <path
            style={st0}
            d="M115.5,13.3v2.1h-4.5v12.7h-2.3v-12.7h-4.5v-2.1h11.3Z"
          />
          <path
            style={st0}
            d="M130,28.2h-2.3v-6.5h-7.3v6.5h-2.3v-14.9h2.3v6.3h7.3v-6.3h2.3v14.9Z"
          />
          <g>
            <path
              style={st0}
              d="M72,13.3h2l5.7,7.2,5.7-7.2h2v14.9h-2.3v-10.8l-5.4,6.8-7.8-9.7"
            />
            <g>
              <polygon
                style={st0}
                points="72 18.8 74.3 21.8 74.3 21.4 72 18.4 72 18.8"
              />
              <polygon
                style={st0}
                points="72 18 74.3 21 74.3 20.6 72 17.7 72 18"
              />
              <polygon
                style={st0}
                points="72 21.2 74.3 24.2 74.3 23.7 72 20.7 72 21.2"
              />
              <polygon
                style={st0}
                points="72 20.4 74.3 23.4 74.3 23 72 20 72 20.4"
              />
              <polygon
                style={st0}
                points="72 22 74.3 25.1 74.3 24.5 72 21.4 72 22"
              />
              <polygon
                style={st0}
                points="72 17.2 74.3 20.2 74.3 19.9 72 16.9 72 17.2"
              />
              <polygon
                style={st0}
                points="72 16.4 74.3 19.4 74.3 19.1 72 16.1 72 16.4"
              />
              <polygon
                style={st0}
                points="72 22.8 74.3 25.8 74.3 25.2 72 22.2 72 22.8"
              />
              <polygon
                style={st0}
                points="72 15.6 74.3 18.6 74.3 18.3 72 15.4 72 15.6"
              />
              <polygon
                style={st0}
                points="72 19.6 74.3 22.6 74.3 22.2 72 19.2 72 19.6"
              />
              <polygon
                style={st0}
                points="72 24.6 72 25.6 72 28.2 74.3 28.2 74.3 27.6 72 24.6"
              />
              <polygon
                style={st0}
                points="72 24.5 74.3 27.5 74.3 26.8 72 23.7 72 24.5"
              />
              <polygon
                style={st0}
                points="72 23.6 74.3 26.6 74.3 26 72 23 72 23.6"
              />
            </g>
          </g>
        </g>
      </g>

      {/* Left MM mark */}
      <path
        style={st0}
        d="M0,13.3h2l5.7,7.2,5.7-7.2h2v14.9h-2.3v-10.8l-5.4,6.8L0,14.4"
      />
      <g>
        <polygon style={st0} points="0 18.8 2.4 21.8 2.4 21.4 0 18.4 0 18.8" />
        <polygon style={st0} points="0 18 2.4 21 2.4 20.6 0 17.7 0 18" />
        <polygon style={st0} points="0 21.2 2.4 24.2 2.4 23.7 0 20.7 0 21.2" />
        <polygon style={st0} points="0 20.4 2.4 23.4 2.4 23 0 20 0 20.4" />
        <polygon style={st0} points="0 22 2.4 25.1 2.4 24.5 0 21.4 0 22" />
        <polygon style={st0} points="0 17.2 2.4 20.2 2.4 19.9 0 16.9 0 17.2" />
        <polygon style={st0} points="0 16.4 2.4 19.4 2.4 19.1 0 16.1 0 16.4" />
        <polygon style={st0} points="0 22.8 2.4 25.8 2.4 25.2 0 22.2 0 22.8" />
        <polygon style={st0} points="0 15.6 2.4 18.6 2.4 18.3 0 15.4 0 15.6" />
        <polygon style={st0} points="0 19.6 2.4 22.6 2.4 22.2 0 19.2 0 19.6" />
        <polygon
          style={st0}
          points="0 24.6 0 25.6 0 28.2 2.4 28.2 2.4 27.6 0 24.6"
        />
        <polygon style={st0} points="0 24.5 2.4 27.5 2.4 26.8 0 23.7 0 24.5" />
        <polygon style={st0} points="0 23.6 2.4 26.6 2.4 26 0 23 0 23.6" />
      </g>
    </svg>
  );
});

Logo.displayName = "Logo";

Logo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
};

export default Logo;
